export enum StudyType {
    Online = 1,
    Offline = 2,
    Hybrid = 3,
}

export const StudyTypesNames: { [p: string]: string } = {
    [StudyType[StudyType.Online]]: 'Online',
    [StudyType[StudyType.Offline]]: 'Offline',
    [StudyType[StudyType.Hybrid]]: 'Hybrid',
};
